<template>
  <v-layout justify-space-between row fill-height>
    <v-flex xs6 sm6 pa-1>
      <connection-manager ref="connectionManager" v-model="connecting" />
      <GmapMap
        ref="mapRef"
        :center="{ lat: -1.3726509, lng: 36.8958014 }"
        :zoom="10"
        map-type-id="terrain"
        style="width: 100%; height: 300px"
      >
        <GmapMarker
          :key="index"
          v-for="(item, index) in riders"
          :icon="{ url: require('../assets/truck_icon.png') }"
          :position="item.position"
          :clickable="true"
          :draggable="false"
          :title="item.name"
          @click="center = item.position"
        />
      </GmapMap>
      <v-card>
        <v-list two-line>
          <template v-for="(item, index) in riders">
            <v-list-tile
              :key="item.title"
              avatar
              ripple
              :to="{
                name: 'riderDeatils',
                params: {
                  id: item.id,
                  latitude: lastKnownLocation(item).lastLatitude,
                  longitude: lastKnownLocation(item).lastLongitude
                }
              }"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{
                  item.phone
                }}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{ item.email }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>{{
                  item.action
                }}</v-list-tile-action-text>
                <v-icon
                  v-if="selected.indexOf(index) < 0"
                  color="grey lighten-1"
                >
                  star_border
                </v-icon>

                <v-icon v-else color="yellow darken-2">
                  star
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < riders.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs6 sm6 pa-1>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>
<script>
import ConnectionManager from './ConnectionManager'
export default {
  components: { ConnectionManager },
  data() {
    return {
      markers: [
        {
          position: {
            lat: parseFloat(1.38),
            lng: parseFloat(103.8)
          }
        }
      ],
      selected: [2],
      connecting: false,
      riders: []
    }
  },
  computed: {},
  methods: {
    toggle(index) {
      const i = this.selected.indexOf(index)

      if (i > -1) {
        this.selected.splice(i, 1)
      } else {
        this.selected.push(index)
      }
    },
    lastKnownLocation: function(item) {
      let location = this.$_.last(item.lastKnownLocations)
      if (location) {
        return location
      } else {
        return {
          lastLatitude: 0,
          lastLongitude: 0
        }
      }
    },
    loadRiders() {
      let that = this
      this.$refs.connectionManager.get('riders', {
        onSuccess(response) {
          let riders = response.data.data
          riders = riders.map(item => {
            let location = that.$_.last(item.lastKnownLocations)
            if (location) {
              item.position = {
                lat: location.lastLatitude,
                lng: location.lastLongitude
              }
            } else {
              item.position = {
                lat: 0,
                lng: 0
              }
            }
            return item
          })
          that.riders = riders
          that.$app.log(riders)
          that.$app.log(that.riders)
        }
      })
    }
  },
  mounted() {
    this.$app.log(`google ${JSON.stringify(this.markers)}`)
    this.loadRiders()
    this.$refs.mapRef.$mapPromise.then(map => {
      map.panTo({ lat: -1.3726509, lng: 36.8958014 })
    })
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Riders.vue